module.exports = __webpack_public_path__ + "static/media/cwc-logo.56e3ba44.png";